{
  "until": "{{duration}} до {{prayer}}",
  "begin_focus": "Начать фокус",
  "add_task": "Добавить задачу",
  "more_tasks": "+{{count}} ещё",
  "fajr_at": "Fajr в {{time}}",
  "schedule_title": "Сегодня",
  "plan_my_day": "Спланировать день",
  "planning": "Планирование…",
  "suggested": "Предложено",
  "keep_plan": "Оставить план",
  "undo_plan": "Отменить",
  "plan_error": "Не удалось спланировать. Попробуйте ещё раз.",
  "plan_empty": "Пока нечего планировать — сначала добавьте задачу.",
  "plan_settled": "Всё уже на своих местах.",
  "view_list": "Список",
  "view_switch_aria": "Переключение между списком и днём",
  "unassigned": "Не запланировано",
  "assign_title": "Молитвенный блок",
  "no_block": "Без блока",
  "assign_aria": "Назначить в молитвенный блок",
  "open_schedule_aria": "Открыть расписание на сегодня",
  "focus_session_label": "{{block}} · Фокус",
  "block_hero": "Глубокая работа до {{prayer}}",
  "moments_away": "{{prayer}} совсем скоро",
  "block_clear": "Всё сделано — отдыхайте до {{prayer}}",
  "alhamdulillah": "Альхамдулиллях",
  "exit_hint": "Esc — выйти тихо",
  "exit_hint_touch": "Нажмите ✕, чтобы выйти тихо",
  "mark_done_aria": "Отметить задачу выполненной",
  "quick_add_placeholder": "Добавить в этот блок…",
  "focus_task_aria": "Сфокусироваться на этой задаче"
}
